import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { Observable, throwError, of} from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CacheService } from './cache.service';


const BASE_SERVER_URL = environment.serverUrl;
const BASE_MOCK_URL = environment.mockUrl;

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private options = {withCredentials:true, headers: new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', 'Basic wnb4sttvaOoauvKh8bNWdbP/ubrfD+tuwQlrYpS3EJELxaLLIIqAeXB+++LLwLqTDt3c4BGnZorMQSJA3yN0AQ==') };

  constructor(private httpClient : HttpClient, private _cacheService: CacheService) { }

  public get(path: string, cacheMins: number = 0): Observable<any> {
    let url = BASE_SERVER_URL + path;
    const data = this._cacheService.load(url);
    if (data !== null) {
      return of<any>(data);
    }
    return this.httpClient.get(url, this.options).pipe(
      switchMap(response => {
        if (cacheMins > 0) {
            // Data will be cached
            this._cacheService.save({
                key: url,
                data: response,
                expirationMins: cacheMins
            })
        }
        return of<any>(response);
      }),
      catchError(this.formatErrors)
    );
  }

  public getDownloadData(path: string): Observable<any> {
    let url = BASE_SERVER_URL + path;   
    return this.httpClient.get(url,  { responseType: 'blob' as 'json',observe: 'response' }).pipe(catchError(this.formatErrors));
  }

  public getMock(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.httpClient.get(BASE_MOCK_URL + path, { params }).pipe(catchError(this.formatErrors));
  }

  public put(path: string, body: object = {}): Observable<any> {
    return this.httpClient
      .put(BASE_SERVER_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public post(path: string, body: object = {}): Observable<any> {
    return this.httpClient
      .post(BASE_SERVER_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public delete(path: string): Observable<any> {
    return this.httpClient.delete(BASE_SERVER_URL + path).pipe(catchError(this.formatErrors));
  }

  public formatErrors(error: any): Observable<any> {
    //window.alert("We are unable to procees. Please try again.");
    return throwError(error.error);
  }

}
